/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as AppRouteImport } from './routes/_app'
import { Route as AppIndexRouteImport } from './routes/_app/index'
import { Route as AppTransactionsRouteImport } from './routes/_app/transactions'
import { Route as AppOrdersRouteImport } from './routes/_app/orders'
import { Route as AppDashboardRouteImport } from './routes/_app/dashboard'
import { Route as AppSplatRouteImport } from './routes/_app/$'

const AppRoute = AppRouteImport.update({
  id: '/_app',
  getParentRoute: () => rootRouteImport,
} as any)
const AppIndexRoute = AppIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppRoute,
} as any)
const AppTransactionsRoute = AppTransactionsRouteImport.update({
  id: '/transactions',
  path: '/transactions',
  getParentRoute: () => AppRoute,
} as any)
const AppOrdersRoute = AppOrdersRouteImport.update({
  id: '/orders',
  path: '/orders',
  getParentRoute: () => AppRoute,
} as any)
const AppDashboardRoute = AppDashboardRouteImport.update({
  id: '/dashboard',
  path: '/dashboard',
  getParentRoute: () => AppRoute,
} as any)
const AppSplatRoute = AppSplatRouteImport.update({
  id: '/$',
  path: '/$',
  getParentRoute: () => AppRoute,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof AppIndexRoute
  '/$': typeof AppSplatRoute
  '/dashboard': typeof AppDashboardRoute
  '/orders': typeof AppOrdersRoute
  '/transactions': typeof AppTransactionsRoute
}
export interface FileRoutesByTo {
  '/$': typeof AppSplatRoute
  '/dashboard': typeof AppDashboardRoute
  '/orders': typeof AppOrdersRoute
  '/transactions': typeof AppTransactionsRoute
  '/': typeof AppIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_app': typeof AppRouteWithChildren
  '/_app/$': typeof AppSplatRoute
  '/_app/dashboard': typeof AppDashboardRoute
  '/_app/orders': typeof AppOrdersRoute
  '/_app/transactions': typeof AppTransactionsRoute
  '/_app/': typeof AppIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths: '/' | '/$' | '/dashboard' | '/orders' | '/transactions'
  fileRoutesByTo: FileRoutesByTo
  to: '/$' | '/dashboard' | '/orders' | '/transactions' | '/'
  id:
    | '__root__'
    | '/_app'
    | '/_app/$'
    | '/_app/dashboard'
    | '/_app/orders'
    | '/_app/transactions'
    | '/_app/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  AppRoute: typeof AppRouteWithChildren
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_app': {
      id: '/_app'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AppRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app/': {
      id: '/_app/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof AppIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/transactions': {
      id: '/_app/transactions'
      path: '/transactions'
      fullPath: '/transactions'
      preLoaderRoute: typeof AppTransactionsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/orders': {
      id: '/_app/orders'
      path: '/orders'
      fullPath: '/orders'
      preLoaderRoute: typeof AppOrdersRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/dashboard': {
      id: '/_app/dashboard'
      path: '/dashboard'
      fullPath: '/dashboard'
      preLoaderRoute: typeof AppDashboardRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/$': {
      id: '/_app/$'
      path: '/$'
      fullPath: '/$'
      preLoaderRoute: typeof AppSplatRouteImport
      parentRoute: typeof AppRoute
    }
  }
}

interface AppRouteChildren {
  AppSplatRoute: typeof AppSplatRoute
  AppDashboardRoute: typeof AppDashboardRoute
  AppOrdersRoute: typeof AppOrdersRoute
  AppTransactionsRoute: typeof AppTransactionsRoute
  AppIndexRoute: typeof AppIndexRoute
}

const AppRouteChildren: AppRouteChildren = {
  AppSplatRoute: AppSplatRoute,
  AppDashboardRoute: AppDashboardRoute,
  AppOrdersRoute: AppOrdersRoute,
  AppTransactionsRoute: AppTransactionsRoute,
  AppIndexRoute: AppIndexRoute,
}

const AppRouteWithChildren = AppRoute._addFileChildren(AppRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  AppRoute: AppRouteWithChildren,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
